import { addDoc, collection } from "firebase/firestore";
import firebaseInit from "../../firebase";
import { logActivity } from "../firebaseActions/activityLog";
import { buildEmailTemplateHtml } from "../../helpers/merch-manager/helper";

const db = firebaseInit.firestore;

export const sendEmail = async ({
  to,
  subject,
  // templateId = null,
  templateData = null,
  html = null,
  sentBy = null,
  email_for,
}) => {
  try {
    /*   const mailPayload = templateId
      ? {
          to,
          message: {},
          sendGrid: {
            templateId,
            dynamicTemplateData: {
              subject,
              ...templateData,
            },
          },
        }
      : {
          to,
          message: {
            subject,
            html,
          },
        }; */

    const mailPayload = {
      to,
      message: {
        subject,
        html: html || buildEmailTemplateHtml(templateData),
      },
    };

    await addDoc(collection(db, "mail"), mailPayload);

    logActivity({
      category: "email",
      event: `email_sent_${email_for}`,
      email: sentBy,
      message: `Email sent to ${to} — ${subject}`,
    });
  } catch (err) {
    console.error("sendEmail failed:", err);
    logActivity({
      category: "email",
      event: `email_send_failure_${email_for}`,
      email: sentBy,
      message: `Failed to send email to ${to} — ${err.message}`,
    });
  }
};
